import loadCookieConsentModule from './modules/CookieConsent.module';
const loadCookieMessageModule = (initialData) => ({
    hasRouter: false,
    modules: [loadCookieConsentModule(initialData)],
});
export default loadCookieMessageModule;
